
import axios from "axios";

const sendCommand = (url, params=null)=>{
    //console.log("sendCommand", url);
    //console.log("sendCommand params", params);
    return axios.get("http://localhost:8099/api/"+url, {params: params});
}
const postCommand = (url, body=null, params=null)=>{
    console.log("sendCommand", url);
    console.log("sendCommand body", body);
    console.log("sendCommand params", params);
    return axios.post("http://localhost:8099/api/"+url, body, {params: params});
}
const deleteCommand = (url, params=null)=>{
    //console.log("sendCommand", url);
    //console.log("sendCommand params", params);
    return axios.delete("http://localhost:8099/api/"+url, {params: params});
}
export {sendCommand, postCommand, deleteCommand}